import { render, staticRenderFns } from "./LapItem.vue?vue&type=template&id=60029fe5&scoped=true&"
import script from "./LapItem.vue?vue&type=script&lang=js&"
export * from "./LapItem.vue?vue&type=script&lang=js&"
import style0 from "./LapItem.vue?vue&type=style&index=0&id=60029fe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60029fe5",
  null
  
)

export default component.exports